export class XHRError extends Error {
    name = 'XHRError';

    constructor(response, body, message) {
        super(message);
        this.response = response;
        this.body = body;
    }
}

export default async function (url, params) {
    let response;

    try {
        response = await new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open(params.method, url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText,
                    });
                }
            };

            xhr.onerror = () => {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText,
                });
            };

            if (params.headers) {
                Object.keys(params.headers).forEach((key) => {
                    xhr.setRequestHeader(key, params.headers[key]);
                });
            }

            xhr.send(params.body);
        });
    } catch (err) {
        throw new XHRError(response, null, 'Network error has occurred.');
    }

    try {
        return await JSON.parse(response);
    } catch (err) {
        throw new XHRError(response, null, err.message);
    }
}
